'use client';

import { useState } from 'react';
import PostCard from '@/components/blog/PostCard';
import { Post } from '@/actions/dtos/blog';

type CategoryFilterProps = {
  posts: Post[];
};

const CategoryFilter = ({ posts }: CategoryFilterProps) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const categories = Array.from(new Set(posts.map((post) => post.category)));
  const filteredPosts = selectedCategory ? posts.filter((post) => post.category === selectedCategory) : posts;

  return (
    <div>
      <div className="mb-8 flex justify-center space-x-2 rounded-lg border bg-base-200 py-2 max-md:flex-col max-md:items-center">
        <button
          className={`w-fit rounded-md px-4 py-2 hover:underline max-md:py-1 ${selectedCategory === null ? 'bg-primary text-primary-content' : 'bg-base-200'}`}
          onClick={() => setSelectedCategory(null)}
        >
          Alle
        </button>
        {categories.map((category) => (
          <button
            key={category}
            className={`rounded-md px-4 py-2 hover:underline ${selectedCategory === category ? 'bg-primary text-primary-content' : 'bg-base-200'}`}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="flex w-full justify-center align-middle">
        <div className="grid max-w-6xl grid-cols-3 content-center gap-4 max-lg:grid-cols-2 max-md:grid-cols-1">
          {filteredPosts.map((post) => (
            <PostCard key={post.id} post={post} size="small" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;
